namespace GeniuzPOS.ReportMasterData {
    export class Report_1503_NColumns {
        static columnsKey = 'ReportMasterData.Report_1503_N';
    }
}
